import { httpsCallable } from 'firebase/functions';
import { IServerResponse } from 'interfaces';
import { functions } from 'services/Firebase';

type ArtistRejectedNotificationRequestData = {
  artistId: string;
  message?: string;
};

export const artisteRejectedNotificationApi = async (artistId: string, message?: string) => {
  const _artisteRejectedNotificationApi = httpsCallable<
    ArtistRejectedNotificationRequestData,
    IServerResponse
  >(functions, 'artisteRejectedNotification');
  return await _artisteRejectedNotificationApi({ artistId: artistId, message });
};

export const artistApprovedNotificationApi = async (artistId: string) => {
  const _artistApprovedNotificationApi = httpsCallable(functions, 'artistApprovedNotification');
  return await _artistApprovedNotificationApi({ artistId: artistId });
};
